<script lang="ts">
    export let color = '#5B6971';
</script>

<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        id="arrow_right"
        d="M7.38458 1.51562L1.84612 6.18107L7.38458 10.8465"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
